export const HELP_CENTER_BASE_URL = "https://help.metroscope.tech/diagnostics";

export const getHelpCenterUrl = (path: string, locale: "fr" | "en") =>
  `${HELP_CENTER_BASE_URL}${locale === "fr" ? "" : "/en"}/${path.replace(/^\/+/, "")}`;
